import React, { Component } from 'react';

//Custom Components
import Header from '../components/Header'
import Hero from '../components/Hero'
import SingleAppShowCase from '../components/SingleAppShowcase'

// Background
import topo from '../img/optimized/topo.webp'

// Images for Hero
import store from '../img/optimized/bassProStore.webp'

// Optimzied Images for Demo
import bCave from '../img/optimized/bCaveShowcase.webp'
import conservation from '../img/optimized/conservationContributionShowcase.webp' 
import b2b from '../img/optimized/b2b_showcase.webp'
import promoPage from '../img/optimized/new_promo_page.webp'
import outfitterPicks from '../img/optimized/outfitter_picks_showcase.webp'
import boats from '../img/optimized/boats_showcase.webp'
import ammo from '../img/optimized/ammo_showcase.webp'
import promoBanner from '../img/optimized/promo_banner_showcase.webp'


// Images for Logo

class Basspro extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <div
        className="align-items-center"
        style={{backgroundColor:'#1E4B2E'}}
      >
        <img 
          className="bg-texture"
          alt=""
          src={topo}
        />

        <Header
          title="Bass Pro Shops" 
          backgroundColor={'#4A765B'}
          textColor={'#FFF'}
          jobTitle={'UX Developer'}
          yearsAtRole={"2021 - Present"}
        /> 

        <Hero
            heroBackground={store}
            jobTitle={"UX Developer"}
            companyName={"Bass Pro Shops"}
            yearsActive={"2021 - Present"}
        />
        
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Bargain Cave"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="A new product recommendation driven approach to clearance and sales with subtle animation."
          appVisual={bCave}
          mirrored={true}
          url="https://www.basspro.com/c/bargain-cave-sale-and-clearance"
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Business Sales"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="The business sales site is a microsite hosted on Bass Pro that allows customers 
          to explore product and service offerings from the B2B team. Customers can get a sense of how their custom order
          will come together and have the ability to sign up for an account or get in touch with a sales representative."
          appVisual={b2b}
          url="https://basspro.com/shop/en/b2b"
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"New Promo Page"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="The new promo page is the home to all of the companies current sales and offers. 
                          It has been fully rebuilt to support the lastest Bass Pro Design standards."
          appVisual={promoPage}
          mirrored={true}
          url="https://www.basspro.com/shop/en/promotions"
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Outfitter Picks"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="Outfitter Picks is a program that highlights products that employees of the company are passionate about.
                          These banners can be found across various product pages on the site."
          appVisual={outfitterPicks}
          url="https://www.basspro.com/shop/en/she-outdoor-performance-rain-jacket-for-ladies"
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Boating Experience"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="A dynamic hero with recommended content pages that help customers find the exact boat they are looking for" 
          appVisual={boats}
          mirrored={true}
          url="https://www.basspro.com/l/fishing-boats"
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Listing Page Shopping Experience"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="A visual filter that is applied to various product listing pages that allows users to quickly filter categories that have clear seperation."
          appVisual={ammo}
          url="https://www.basspro.com/l/ammunition"
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Conservation Contribution"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="A landing page that makes supporting the conservation cause that you care about most incredibly easily."
          appVisual={conservation}
          mirrored={true}
          // url=""
        /> 
        <SingleAppShowCase
          backgroundColor={'#1E4B2E'}
          appTitle={"Promo Banner A/B Split Test"}
          logoWidth={"50%"}
          extraPadding={'5%'}
          lightText={true}
          appDescription="An A/B split test to replace our static header with an expandable banner that can expand to
          reveal all of the promotions that are currently on the site. This test ran throughout Holiday 2023."
          appVisual={promoBanner}
        /> 
        
      </div>
    );
  }
}

export default Basspro;



// WEBPACK FOOTER //
// ./src/screens/BassPro.js